/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { MultiSelect } from "@progress/kendo-react-dropdowns";

export default function ReactHookFormMultiSelect({
  label,
  name,
  isRequired,
  placeholder,
  filterable,
  rules,
  id,
  text,
  data = [],
  disabled,
  errors,
  control,
  onChange,
  multiSelectProps,
}) {
  const [filteredData, setFilteredData] = useState(data);

  // keep filtered data synced
  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleFilterChange = (e) => {
    const filterValue = e.filter.value.toLowerCase();

    const filtered = data.filter((item) =>
      String(item[text]).toLowerCase().includes(filterValue),
    );

    setFilteredData(filtered);
  };

  return (
    <FormControl isRequired={Boolean(isRequired)}>
      <FormLabel>{label}</FormLabel>

      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => (
          <>
            <MultiSelect
              {...multiSelectProps}
              className="
                  [&_.k-input-values]:max-h-[72px]
                  [&_.k-input-values]:overflow-y-auto
                  [&_.k-input-values::-webkit-scrollbar]:cursor-pointer
                  [&_.k-chip]:whitespace-nowrap h-10"
              disabled={disabled}
              data={filteredData}
              value={field.value || []}
              textField={text}
              dataItemKey={id}
              filterable={filterable}
              onFilterChange={handleFilterChange}
              placeholder={placeholder}
              onChange={(e) => {
                let newValue = e.value;

                if (onChange) {
                  const result = onChange(e.value);

                  if (Array.isArray(result)) {
                    newValue = result;
                  }
                }

                field.onChange(newValue);
              }}
            />

            {errors?.[name] ? (
              <span className="text-red-500 text-sm">
                {errors[name].message}
              </span>
            ) : null}
          </>
        )}
      />
    </FormControl>
  );
}
